import PropTypes from 'prop-types';

import {OEFNHelpEntryType, OEFNHelpPropTypes, OEFNHelpEntryFactory} from '../flow-nav/help/oe-flow-nav-help-model';
import {OEManualViewLinks} from '../manual-view/oe-manual-view-model';
import OEIconCodes from '../../../lib/oe-icon-codes';

export const OEHelpViewTypes = {
    std:                'std',
    start:              'start',
    manual:             'manual'
};

//
export const OEHelpViewEntryType = OEFNHelpEntryType;

//
export const OEHelpViewConfigDecl = PropTypes.shape(Object.assign({
    type:               PropTypes.oneOf([OEHelpViewTypes.std, OEHelpViewTypes.start, OEHelpViewTypes.manual]),
    logo:               PropTypes.string,
    showAtStartUp:      PropTypes.bool,
}, OEFNHelpPropTypes.propTypes));

//
export class OEHelpViewConfigFactory {

    constructor(config, ref = true) {
        this.set(config, ref);
    }

    set(config, ref = false)    {      // ref == true -> overwrite reference
        if(typeof(config) !== 'object' || config === null)    {

            if(!ref && this.config) {
                this.config.type = OEHelpViewTypes.std;
                this.config.logo = undefined;
                this.config.showAtStartUp = false;
                this.config.locStringPrefix = undefined;

                if(!Array.isArray(this.config.entries)) {
                    this.config.entries = [];
                } else {
                    if(this.config.entries.length) this.config.entries.splice(0, this.config.entries.length);
                }

                this.config.autoSpacerHeight = '2.125em';
            } else {
                this.config = {
                    type: OEHelpViewTypes.std,
                    showAtStartUp: false,
                    entries: [],
                    autoSpacerHeight: '2.125em'
                };
            }

        } else {

            if(ref) {
                this.config = config;
            } else {
                if(!this.config)    this.config = {};
                
                this.config.type = config.type;
                this.config.logo = config.logo;
                this.config.showAtStartUp = config.showAtStartUp;
                this.config.locStringPrefix = config.locStringPrefix;

                if(!Array.isArray(this.config.entries))    this.config.entries = [];
                this.config.entries.splice(0, this.config.entries.length);
                if(Array.isArray(config.entries))      this.config.entries.splice(this.config.entries.length, 0, ...config.entries);

                this.config.autoSpacerHeight = config.autoSpacerHeight;
            }

            if(typeof(this.config.type) !== 'string')    this.config.type = OEHelpViewTypes.std;
            if(!Array.isArray(this.config.entries))    this.config.entries = [];
            if(typeof(this.config.autoSpacerHeight) !== 'number' && typeof(this.config.autoSpacerHeight) !== 'string')    this.config.autoSpacerHeight = '2.125em';
        }

        this.entries = new OEFNHelpEntryFactory(this.config.entries)

        return this;
    }

    build(copy = true)   {
        if(!copy)    return this.config;
        return clone(this.config);
    }

    clear() {
        return this.set(undefined, false);
    }

    std()   {
        return this.set(OEHelpViewConfigFactory.buildStdConfig(), false);
    }

    stdManual()   {
        return this.set(OEHelpViewConfigFactory.buildStdManualConfig(), false);
    }
    
    stdManualVideoTutorial()   {
        return this.set(OEHelpViewConfigFactory.buildStdManualVideoTutorialConfig(), false);
    }

    stdRightsManualVideoTutorial()   {
        return this.set(OEHelpViewConfigFactory.buildStdRightsManualVideoTutorialConfig(), false);
    }

    stdInteractiveManualVideoTutorial()   {
        return this.set(OEHelpViewConfigFactory.buildStdInteractiveManualVideoTutorialConfig(), false);
    }

    stdInteractiveManualManualVideo()   {
        return this.set(OEHelpViewConfigFactory.buildStdInteractiveManualManualVideoConfig(), false);
    }

    setTestAll()    {
        return this.set(OEHelpViewConfigFactory.buildTestAllConfig(), false);
    }

    insertEntryAtIndex(index, entry)   {
        this.entries.insertEntryAtIndex(index, entry);
        return this;
    }

    addEntry(entry) {
        this.entries.addEntry(entry);
        return this;
    }

    removeEntryAtIndex(index)   {
        this.entries.removeEntryAtIndex(index);
        return this;
    }

    replaceEntryAtIndex(index, entry)   {
        this.entries.replaceEntryAtIndex(index, entry);
        return this;
    }

    insertEntryRelativeToType(type, offset, entry)  {
        this.entries.insertEntryRelativeToType(type, offset, entry);
        return this;
    }

    insertEntryAfterType(type, entry) {
        this.entries.insertEntryAfterType(type, entry);
        return this;
    }

    insertEntryInFrontOfType(type, entry) {
        this.entries.insertEntryInFrontOfType(type, entry);
        return this;
    }

    replaceEntryByType(type, entry) {
        this.entries.replaceEntryByType(type, entry);
        return this;
    }

    removeEntryByType(type, fn)  {
        this.entries.removeEntryByType(type, fn);
        return this;
    }

    modifyEntryByType(type, fn)    {
        this.entries.modifyEntryByType(type, fn);
        return this;
    }

    removeTutorEntries()    {
        return this.removeEntryByType([OEHelpViewEntryType.tutorReset, OEHelpViewEntryType.disableTutor]);
    }

    setLogo(logo)   {
        this.config.logo = logo;
        return this;
    }

    setShowAtStartUp(showAtStartUp)   {
        this.config.showAtStartUp = showAtStartUp;
        return this;
    }

    setLocStringPrefix(prefix)   {
        this.config.locStringPrefix = prefix;
        return this;
    }

    setAutoSpacerHeight(height)   {
        this.config.autoSpacerHeight = typeof(height) === 'number' || typeof(height) === 'string' ? height : '2.125em';
        return this;
    }

    setEntries(entries)   {
        return this.entries.set(entries)
    }    
};

OEHelpViewConfigFactory.buildStdConfig = function()  {
    return {
        type: OEHelpViewTypes.std,
        logo: null,
        showAtStartUp: false,
        entries: [
            {type: OEHelpViewEntryType.spacer, height: '4.625em' /*74*/},
            {type: OEHelpViewEntryType.advice},
            {type: OEHelpViewEntryType.quickStart},
            {type: OEHelpViewEntryType.tutorReset},
            {type: OEHelpViewEntryType.disableTutor},
            {type: OEHelpViewEntryType.spacer, height: '1.875em' /*30*/},
            {type: OEHelpViewEntryType.credits},
            {type: OEHelpViewEntryType.feedback}
        ],
        autoSpacerHeight: '2.125em'     //34
    };
};

OEHelpViewConfigFactory.buildStdManualConfig = function()  {
    return {
        type: OEHelpViewTypes.std,
        logo: null,
        showAtStartUp: false,
        entries: [
            {type: OEHelpViewEntryType.spacer, height: '4.625em' /*74*/},
            {type: OEHelpViewEntryType.manual, link: OEManualViewLinks.app},
            {type: OEHelpViewEntryType.quickStart},
            {type: OEHelpViewEntryType.tutorReset},
            {type: OEHelpViewEntryType.disableTutor},
            {type: OEHelpViewEntryType.spacer, height: '1.875em' /*30*/},
            {type: OEHelpViewEntryType.credits},
            {type: OEHelpViewEntryType.feedback}
        ],
        autoSpacerHeight: '2.125em'     //34
    };
};

OEHelpViewConfigFactory.buildStdManualVideoTutorialConfig = function()  {
    return {
        type: OEHelpViewTypes.std,
        logo: null,
        showAtStartUp: false,
        entries: [
            {type: OEHelpViewEntryType.spacer, height: '4.625em' /*74*/},
            {type: OEHelpViewEntryType.manual, link: OEManualViewLinks.app},
            {type: OEHelpViewEntryType.quickStart},
            {type: OEHelpViewEntryType.videoTutorials},
            {type: OEHelpViewEntryType.tutorReset},
            {type: OEHelpViewEntryType.disableTutor},
            {type: OEHelpViewEntryType.spacer, height: '1.875em' /*30*/},
            {type: OEHelpViewEntryType.credits},
            {type: OEHelpViewEntryType.feedback}
        ],
        autoSpacerHeight: '2.125em'     //34
    };
};

OEHelpViewConfigFactory.buildStdRightsManualVideoTutorialConfig = function()  {
    return {
        type: OEHelpViewTypes.std,
        logo: null,
        showAtStartUp: false,
        entries: [
            {type: OEHelpViewEntryType.spacer, height: '4.625em' /*74*/},
            {type: OEHelpViewEntryType.usageRights},
            {type: OEHelpViewEntryType.manual, link: OEManualViewLinks.app},
            {type: OEHelpViewEntryType.videoTutorials},
            {type: OEHelpViewEntryType.tutorReset},
            {type: OEHelpViewEntryType.disableTutor},
            {type: OEHelpViewEntryType.spacer, height: '1.875em' /*30*/},
            {type: OEHelpViewEntryType.credits},
            {type: OEHelpViewEntryType.feedback}
        ],
        autoSpacerHeight: '2.125em'     //34
    };
};

OEHelpViewConfigFactory.buildStdInteractiveManualVideoTutorialConfig = function()  {
    return {
        type: OEHelpViewTypes.std,
        logo: null,
        showAtStartUp: false,
        entries: [
            {type: OEHelpViewEntryType.spacer, height: '4.625em' /*74*/},
            {type: OEHelpViewEntryType.manualInteractive},
            {type: OEHelpViewEntryType.manual, link: OEManualViewLinks.app, stringId: 'help_view_manual_pdf'},
            {type: OEHelpViewEntryType.videoTutorials},
            {type: OEHelpViewEntryType.tutorReset},
            {type: OEHelpViewEntryType.disableTutor},
            {type: OEHelpViewEntryType.spacer, height: '2.3125em' /*37*/},
        ],
        autoSpacerHeight: '2.125em'     //34
    };
};

OEHelpViewConfigFactory.buildStdInteractiveManualManualVideoConfig = function()  {
    return {
        type: OEHelpViewTypes.std,
        logo: null,
        showAtStartUp: false,
        entries: [
            {type: OEHelpViewEntryType.spacer, height: '4.625em' /*74*/},
            {type: OEHelpViewEntryType.manualInteractive},
            {type: OEHelpViewEntryType.manual, link: OEManualViewLinks.app, stringId: 'help_view_manual_pdf'},
            {type: OEHelpViewEntryType.manual, link: OEManualViewLinks.videoTutorial, viewTitleId: 'help_view_manual_video_tutorial', stringId: 'help_view_manual_video_tutorial', icon: OEIconCodes.helpView.videoTutorials},
            {type: OEHelpViewEntryType.tutorReset},
            {type: OEHelpViewEntryType.disableTutor},
            {type: OEHelpViewEntryType.spacer, height: '2.3125em' /*37*/},
            {type: OEHelpViewEntryType.feedback}
        ],
        autoSpacerHeight: '2.125em'     //34
    };
};

OEHelpViewConfigFactory.buildTestAllConfig = function()  {
    return {
        type: OEHelpViewTypes.std,
        logo: null,
        showAtStartUp: false,
        entries: [
            {type: OEHelpViewEntryType.spacer, height: '4.625em' /*74*/},
            {type: OEHelpViewEntryType.advice},
            {type: OEHelpViewEntryType.manualInteractive},
            {type: OEHelpViewEntryType.manual, link: OEManualViewLinks.app, stringId: 'help_view_manual_pdf'},
            {type: OEHelpViewEntryType.manual, link: OEManualViewLinks.videoTutorial, viewTitleId: 'help_view_manual_video_tutorial', stringId: 'help_view_manual_video_tutorial', icon: OEIconCodes.helpView.videoTutorials},
            {type: OEHelpViewEntryType.quickStart},
            {type: OEHelpViewEntryType.videoTutorials},
            {type: OEHelpViewEntryType.usageRights},
            {type: OEHelpViewEntryType.licenseAgreement},
            {type: OEHelpViewEntryType.tutorReset},
            {type: OEHelpViewEntryType.disableTutor},
            {type: OEHelpViewEntryType.credits},
            {type: OEHelpViewEntryType.feedback},
            {type: OEHelpViewEntryType.spacer, height: '2.3125em' /*37*/},
        ],
        autoSpacerHeight: '2.125em'     //34
    };
};